"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileProductsService = void 0;
const tslib_1 = require("tslib");
const request_1 = require("../core/request");
class MobileProductsService {
    /**
     * @param requestBody
     * @returns ProductsResponse Success
     * @throws ApiError
     */
    static mobileProductsSearch(requestBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/products/mobile/search`,
                body: requestBody,
                errors: {
                    300: `Redirect`,
                    400: `Bad Request`,
                    500: `Server Error`,
                },
            });
            return result.body;
        });
    }
}
exports.MobileProductsService = MobileProductsService;
//# sourceMappingURL=MobileProductsService.js.map